export const GET_API_KEYS_REQUEST = "GET_API_KEYS_REQUEST";
export const GET_API_KEYS_SUCCESS = "GET_API_KEYS_SUCCESS";
export const GET_API_KEYS_FAILURE = "GET_API_KEYS_FAILURE";

export const CREATE_API_KEY_REQUEST = "CREATE_API_KEY_REQUEST";
export const CREATE_API_KEY_SUCCESS = "CREATE_API_KEY_SUCCESS";
export const CREATE_API_KEY_FAILURE = "CREATE_API_KEY_FAILURE";

export const GET_API_KEY_REQUEST = "GET_API_KEY_REQUEST";
export const GET_API_KEY_SUCCESS = "GET_API_KEY_SUCCESS";
export const GET_API_KEY_FAILURE = "GET_API_KEY_FAILURE";

export const UPDATE_API_KEY_REQUEST = "UPDATE_API_KEY_REQUEST";
export const UPDATE_API_KEY_SUCCESS = "UPDATE_API_KEY_SUCCESS";
export const UPDATE_API_KEY_FAILURE = "UPDATE_API_KEY_FAILURE";

export const DELETE_API_KEY_REQUEST = "DELETE_API_KEY_REQUEST";
export const DELETE_API_KEY_SUCCESS = "DELETE_API_KEY_SUCCESS";
export const DELETE_API_KEY_FAILURE = "DELETE_API_KEY_FAILURE";

export const CLEAR_API_KEY_SECRET = "CLEAR_API_KEY_SECRET";

export const GET_API_KEY_PERMISSIONS_REQUEST = "GET_API_KEY_PERMISSIONS_REQUEST";
export const GET_API_KEY_PERMISSIONS_SUCCESS = "GET_API_KEY_PERMISSIONS_SUCCESS";
export const GET_API_KEY_PERMISSIONS_FAILURE = "GET_API_KEY_PERMISSIONS_FAILURE";

export const getApiKeysRequest = () => ({
    type: GET_API_KEYS_REQUEST
})

export const getApiKeysSuccess = (result) => ({
    type: GET_API_KEYS_SUCCESS,
    payload: {
        result
    }
})

export const getApiKeysFailure = (error) => ({
    type: GET_API_KEYS_FAILURE,
    payload: {
        error
    }
})

export const createApiKeyRequest = (apiKey) => ({
    type: CREATE_API_KEY_REQUEST,
    params: {
        apiKey
    }
})

export const createApiKeySuccess = (apiKey) => ({
    type: CREATE_API_KEY_SUCCESS,
    payload: {
        apiKey
    }
})

export const createApiKeyFailure = (error) => ({
    type: CREATE_API_KEY_FAILURE,
    payload: {
        error
    }
})

export const getApiKeyRequest = (apiKeyId) => ({
    type: GET_API_KEY_REQUEST,
    params: {
        apiKeyId
    }
})

export const getApiKeySuccess = (apiKey) => ({
    type: GET_API_KEY_SUCCESS,
    payload: {
        apiKey
    }
})

export const getApiKeyFailure = (error) => ({
    type: GET_API_KEY_FAILURE,
    payload: {
        error
    }
})

export const updateApiKeyRequest = (apiKeyId, updatedApiKey) => ({
    type: UPDATE_API_KEY_REQUEST,
    params: {
        apiKeyId,
        updatedApiKey
    }
})

export const updateApiKeySuccess = (apiKey) => ({
    type: UPDATE_API_KEY_SUCCESS,
    payload: {
        apiKey
    }
})

export const updateApiKeyFailure = (error) => ({
    type: UPDATE_API_KEY_FAILURE,
    payload: {
        error
    }
})

export const deleteApiKeyRequest = (apiKeyId) => ({
    type: DELETE_API_KEY_REQUEST,
    params: {
        apiKeyId
    }
})

export const deleteApiKeySuccess = (apiKeyId) => ({
    type: DELETE_API_KEY_SUCCESS,
    payload: {
        apiKeyId
    }
})

export const deleteApiKeyFailure = (error) => ({
    type: DELETE_API_KEY_FAILURE,
    payload: {
        error
    }
})

// Drops the one-time plaintext key from the store once the user has dismissed it.
export const clearApiKeySecret = () => ({
    type: CLEAR_API_KEY_SECRET
})

export const getApiKeyPermissionRequest = () => ({
    type: GET_API_KEY_PERMISSIONS_REQUEST
})

export const getApiKeyPermissionSuccess = (permission) => ({
    type: GET_API_KEY_PERMISSIONS_SUCCESS,
    payload: {
        permission
    }
})

export const getApiKeyPermissionFailure = (error) => ({
    type: GET_API_KEY_PERMISSIONS_FAILURE,
    payload: {
        error
    }
})
